import { Routes, Route } from "react-router-dom";
import "rc-dropdown/assets/index.css";
import "rc-menu/assets/index.css";
import Style from "./style";

import {
  PublicRoute,
  PrivateRoute,
  ProtectRoute,
  InitPageQueryRouter,
  InitProGradeQueryRouter,
  StartPageRouter,
} from "./lib/conditionalRouter";
import NotFound from "./ui/NotFound";
import InternalServerError from "./ui/InternalServerError";

// === 로그인 관련 페이지
import LoginManager from "./ui/LoginManager";
import LoginAdmin from "./ui/LoginAdmin";
import SignupManager from "./ui/SignupManager";
import SignupAdmin from "./ui/SignupAdmin";
import FindManagerId from "./ui/FindManagerId";
import FindManagerPw from "./ui/FindManagerPw";

// === 프렌차이즈 매니저, 지점 매니저의 페이지
import MyFranchise from "./ui/MyFranchise";
import MyFranchiseEdit from "./ui/MyFranchiseEdit";
import MyStore from "./ui/MyStore";
import MyStoreEdit from "./ui/MyStoreEdit";
import MyEventList from "./ui/MyEventList";
import MyFranchiseManagerTicketList from "./ui/MyFranchiseManagerTicketList";
import MyFranchiseMemberTicketList from "./ui/MyFranchiseMemberTicketList";
import MyFranchiseTicket from "./ui/MyFranchiseTicket";

// === 관리자의 페이지

import MyAdminEdit from "./ui/MyAdminEdit";

// 회원 관리
import UserList from "./ui/UserList";
import UserDetail from "./ui/UserDetail";
import AdminList from "./ui/AdminList";
import FranchiseManagerList from "./ui/FranchiseManagerList";
import FranchiseManagerDetail from "./ui/FranchiseManagerDetail";
import StoreManagerDetail from "./ui/StoreManagerDetail";

// 대회 시리즈 관리
import SeriesList from "./ui/SeriesList";
import SeriesDetail from "./ui/SeriesDetail";
import SeriesCreate from "./ui/SeriesCreate";
import SeriesEdit from "./ui/SeriesEdit";

// 대회 관리
import EventList from "./ui/EventList";
import EventDetail from "./ui/EventDetail";
import EventCreate from "./ui/EventCreate";
import EventEdit from "./ui/EventEdit";
import EventParticipantList from "./ui/EventParticipantList";
import EventQr from "./ui/EventQr";

// 칼럼 관리
import NoticeList from "./ui/NoticeList";
import NoticeDetail from "./ui/NoticeDetail";
import NoticeCreate from "./ui/NoticeCreate";
import NoticeEdit from "./ui/NoticeEdit";
import AdList from "./ui/AdList";
import AdDetail from "./ui/AdDetail";
import AdCreate from "./ui/AdCreate";
import AdEdit from "./ui/AdEdit";
import YoutubeList from "./ui/YoutubeList";
import YoutubeCreate from "./ui/YoutubeCreate";
import YoutubeEdit from "./ui/YoutubeEdit";
import MediaList from "./ui/MediaList";
import MediaCreate from "./ui/MediaCreate";
import MediaEdit from "./ui/MediaEdit";

// 타이머 광고 관리
import AdTimerList from "./ui/AdTimerList";
import AdTimerCreate from "./ui/AdTimerCreate";
import AdTimerEdit from "./ui/AdTimerEdit";

// 트라이아웃 관리
import TryoutExamList from "./ui/TryoutExamList";
import TryoutExamDetail from "./ui/TryoutExamDetail";
import TryoutExamCreate from "./ui/TryoutExamCreate";
import TryoutPtPayList from "./ui/TryoutPtPayList";
import TryoutWtPayList from "./ui/TryoutWtPayList";

// 사용자 티켓현황
import SeedTicketStatus from "./ui/SeedTicketStatus";
import SeedTicketLog from "./ui/SeedTicketLog";
import JoinTicketStatus from "./ui/JoinTicketStatus";

import {
  ROLE_EVENT_ADMIN,
  ROLE_FRANCHISE_MANAGER,
  ROLE_STORE_ADMIN,
  ROLE_SITE_ADMIN,
  ROLE_STORE_MANAGER,
  ROLE_SUPER_ADMIN,
  ROLE_MARKETING_ADMIN,
} from "shared/constant/lookup/role";
import { useEffect, useState } from "react";
import Maintenance from "./ui/Maintenance";
import useLogoutEvent from "app/ui/Aside/model/useLogoutEvent";

const Router = () => {
  const [, logout] = useLogoutEvent();
  const [isMaintenance, setIsMaintenance] = useState(
    process.env.REACT_APP_MAINTENANCE === "true"
  );

  useEffect(() => {
    if (isMaintenance) {
      logout();
    }
  }, []);

  return (
    <Style.Main>
      <Routes>
        {isMaintenance ? (
          <Route
            path="/"
            element={<Maintenance setIsMaintenance={setIsMaintenance} />}
          />
        ) : (
          <>
            {/* 비로그인 */}
            <Route element={<PublicRoute />}>
              <Route element={<InitPageQueryRouter />}>
                <Route path="/signup/manager" element={<SignupManager />} />
              </Route>
              <Route path="/login/manager" element={<LoginManager />} />
              <Route path="/find/manager/id" element={<FindManagerId />} />
              <Route
                path="/find/manager/password"
                element={<FindManagerPw />}
              />
              <Route path="/login/admin" element={<LoginAdmin />} />
              <Route path="/signup/admin" element={<SignupAdmin />} />
            </Route>

            {/* 로그인 */}
            <Route element={<PrivateRoute />}>
              <Route index element={<StartPageRouter />} />

              <Route path="/admin/my/edit" element={<MyAdminEdit />} />

              {/* 최고 관리자 */}
              <Route
                element={
                  <ProtectRoute permissionRoleList={[ROLE_SUPER_ADMIN]} />
                }
              >
                <Route element={<InitPageQueryRouter />}>
                  <Route path="/admin" element={<AdminList />} />
                  <Route element={<InitProGradeQueryRouter />}>
                    <Route path="/exam" element={<TryoutExamList />} />
                  </Route>
                  <Route path="/wt-pay/list" element={<TryoutWtPayList />} />
                  <Route path="/pt-pay/list" element={<TryoutPtPayList />} />

                  <Route
                    path="/exam/:idx/detail"
                    element={<TryoutExamDetail />}
                  />
                  <Route path="/ad-timer" element={<AdTimerList />} />
                </Route>
                <Route
                  path="/exam/:idx/create"
                  element={<TryoutExamCreate />}
                />
                <Route path="/ad-timer/create" element={<AdTimerCreate />} />
                <Route path="/ad-timer/:idx/edit" element={<AdTimerEdit />} />
              </Route>

              {/* 최고 관리자 & 마케팅 관리자 */}
              <Route
                element={
                  <ProtectRoute
                    permissionRoleList={[
                      ROLE_SUPER_ADMIN,
                      ROLE_MARKETING_ADMIN,
                    ]}
                  />
                }
              >
                <Route element={<InitPageQueryRouter />}>
                  <Route path="/notice" element={<NoticeList />} />
                  <Route path="/ad" element={<AdList />} />
                  <Route path="/youtube" element={<YoutubeList />} />
                  <Route path="/media" element={<MediaList />} />
                </Route>
                <Route path="/notice/:idx/detail" element={<NoticeDetail />} />
                <Route path="/notice/create" element={<NoticeCreate />} />
                <Route path="/notice/:idx/edit" element={<NoticeEdit />} />
                <Route path="/ad/:idx/detail" element={<AdDetail />} />
                <Route path="/ad/create" element={<AdCreate />} />
                <Route path="/ad/:idx/edit" element={<AdEdit />} />
                <Route path="/youtube/create" element={<YoutubeCreate />} />
                <Route path="/youtube/:idx/edit" element={<YoutubeEdit />} />
                <Route path="/media/create" element={<MediaCreate />} />
                <Route path="/media/:idx/edit" element={<MediaEdit />} />
              </Route>

              {/* 최고 관리자 & 매장 관리자 */}
              <Route
                element={
                  <ProtectRoute
                    permissionRoleList={[ROLE_SUPER_ADMIN, ROLE_STORE_ADMIN]}
                  />
                }
              >
                <Route element={<InitPageQueryRouter />}>
                  <Route
                    path="/manager/franchise"
                    element={<FranchiseManagerList />}
                  />
                </Route>
                <Route
                  path="/manager/franchise/:idx/detail"
                  element={<FranchiseManagerDetail />}
                />
              </Route>

              {/* 최고 관리자 & 대회 관리자 */}
              <Route
                element={
                  <ProtectRoute
                    permissionRoleList={[ROLE_SUPER_ADMIN, ROLE_EVENT_ADMIN]}
                  />
                }
              >
                <Route element={<InitPageQueryRouter />}>
                  <Route path="/user" element={<UserList />} />
                  <Route path="/user/:idx/detail" element={<UserDetail />} />
                </Route>
                <Route path="/series/create" element={<SeriesCreate />} />
                <Route path="/series/:idx/edit" element={<SeriesEdit />} />
              </Route>

              {/* 최고 관리자 & 매장 관리자 & 프렌차이즈 매니저 */}
              <Route
                element={
                  <ProtectRoute
                    permissionRoleList={[
                      ROLE_SUPER_ADMIN,
                      ROLE_STORE_ADMIN,
                      ROLE_FRANCHISE_MANAGER,
                    ]}
                  />
                }
              >
                <Route element={<InitPageQueryRouter />}>
                  <Route
                    path="/manager/store/:idx/detail"
                    element={<StoreManagerDetail />}
                  />
                </Route>
              </Route>

              {/* 최고 관리자 & 매장 관리자 & 대회 관리자 */}
              <Route
                element={
                  <ProtectRoute
                    permissionRoleList={[
                      ROLE_SUPER_ADMIN,
                      ROLE_STORE_ADMIN,
                      ROLE_EVENT_ADMIN,
                    ]}
                  />
                }
              >
                <Route element={<InitPageQueryRouter />}>
                  <Route path="/series" element={<SeriesList />} />
                  <Route
                    path="/series/:idx/detail"
                    element={<SeriesDetail />}
                  />
                </Route>
              </Route>

              {/* 프렌차이즈 매니저 */}
              <Route
                element={
                  <ProtectRoute permissionRoleList={[ROLE_FRANCHISE_MANAGER]} />
                }
              >
                <Route path="/manager/my/edit" element={<MyFranchiseEdit />} />
              </Route>

              {/* 프렌차이즈 매니저 & 지점 매니저 */}
              <Route
                element={
                  <ProtectRoute
                    permissionRoleList={[
                      ROLE_FRANCHISE_MANAGER,
                      ROLE_STORE_MANAGER,
                    ]}
                  />
                }
              >
                <Route element={<InitPageQueryRouter />}>
                  <Route path="/store/my" element={<MyStore />} />
                  <Route path="/event/my" element={<MyEventList />} />
                  <Route
                    path="/ticket-member"
                    element={<MyFranchiseMemberTicketList />}
                  />
                </Route>
                <Route path="/manager/my" element={<MyFranchise />} />
                <Route path="/store/my/edit" element={<MyStoreEdit />} />
                <Route path="/ticket" element={<MyFranchiseTicket />} />
                <Route
                  path="/ticket-manager"
                  element={<MyFranchiseManagerTicketList />}
                />
              </Route>

              {/* 최고 관리자 & 대회 관리자 & 현장 관리자 & 프렌차이즈 매니저 & 지점 매니저 */}
              <Route
                element={
                  <ProtectRoute
                    permissionRoleList={[
                      ROLE_SUPER_ADMIN,
                      ROLE_EVENT_ADMIN,
                      ROLE_SITE_ADMIN,
                      ROLE_FRANCHISE_MANAGER,
                      ROLE_STORE_MANAGER,
                    ]}
                  />
                }
              >
                <Route element={<InitPageQueryRouter />}>
                  <Route path="/event" element={<EventList />} />
                  <Route
                    path="/event/:idx/participant"
                    element={<EventParticipantList />}
                  />
                  <Route path="/event/:idx/detail" element={<EventDetail />} />
                  <Route path="/event/create" element={<EventCreate />} />
                  <Route path="/event/:idx/edit" element={<EventEdit />} />
                </Route>
                <Route path="/event/:idx/qr" element={<EventQr />} />
              </Route>
            </Route>

            {/* @Desc 티켓 보유현황 */}
            <Route path="/seed-ticket-status" element={<SeedTicketStatus />} />
            <Route path="/seed-ticket-log" element={<SeedTicketLog />} />
            <Route path="/join-ticket-status" element={<JoinTicketStatus />} />
            {/* 상관 없음 */}
            <Route path="/500" element={<InternalServerError />} />
          </>
        )}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Style.Main>
  );
};

export default Router;
